import React from 'react';
import { Trophy, Calendar, Star, Globe } from 'lucide-react';

const OverWKPage = () => {
  const winnaars = [
    { jaar: 2022, land: "Argentinië", stad: "Doha" },
    { jaar: 2018, land: "Frankrijk", stad: "Moskou" },
    { jaar: 2014, land: "Duitsland", stad: "Rio de Janeiro" },
    { jaar: 2010, land: "Spanje", stad: "Johannesburg" },
    { jaar: 2006, land: "Italië", stad: "Berlijn" }
  ];

  return (
    <div>
      <section className="bg-gradient-to-r from-amber-600 to-orange-600 text-white py-12">
        <div className="container mx-auto px-4">
          <h1 className="text-4xl font-bold mb-4">WK Geschiedenis</h1>
          <p className="text-xl opacity-90">De rijke historie van het Wereldkampioenschap Voetbal</p>
        </div>
      </section>

      <section className="py-12">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold mb-8">Recente Winnaars</h2>
          <div className="bg-white rounded-xl shadow-md overflow-hidden">
            <table className="w-full">
              <thead className="bg-amber-100">
                <tr>
                  <th className="px-6 py-4 text-left">Jaar</th>
                  <th className="px-6 py-4 text-left">Winnaar</th>
                  <th className="px-6 py-4 text-left">Finale Stad</th>
                </tr>
              </thead>
              <tbody>
                {winnaars.map((winnaar, index) => (
                  <tr key={index} className="border-b hover:bg-gray-50">
                    <td className="px-6 py-4 font-semibold">{winnaar.jaar}</td>
                    <td className="px-6 py-4">
                      <div className="flex items-center">
                        <Trophy className="w-4 h-4 mr-2 text-amber-500" />
                        {winnaar.land}
                      </div>
                    </td>
                    <td className="px-6 py-4">{winnaar.stad}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </section>

      <section className="py-12 bg-amber-50">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold mb-8">WK Feiten</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-4xl">
            <div className="bg-white rounded-xl shadow-md p-6">
              <h3 className="font-bold text-xl mb-4">Eerste WK</h3>
              <p className="text-gray-600">
                Het eerste WK werd in 1930 gehouden in Uruguay. Uruguay won het toernooi door Argentinië te verslaan in de finale.
              </p>
            </div>
            <div className="bg-white rounded-xl shadow-md p-6">
              <h3 className="font-bold text-xl mb-4">Meeste Titels</h3>
              <p className="text-gray-600">
                Brazilië is met 5 wereldtitels (1958, 1962, 1970, 1994, 2002) het succesvolste land in de WK-geschiedenis.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default OverWKPage;